export class NotificationViewDto {
  id!: number;
  createdDate!: Date;
  startDate!: Date;
  endDate!: Date;
  key!: NotificationKeyEnum;
  customerId!: number;
  messageParams!: { TransportId: string; OfferId: string; BasketId: string; CustomerId: string };
  level!: NotificationLevel;
  status!: NotificationStatusEnum;

  constructor(data: any = {}) {
    Object.assign(this, data);
    this.level = data.level ? LIST_NOTIFICATION_LEVEL[data.level] : LIST_NOTIFICATION_LEVEL.INFO;
  }
}

export class NotificationLevel {
  public code!: NotificationLevelEnum;
  public icon!: string;
  public color!: string;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}

export enum NotificationLevelEnum {
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  WARNING = 'WARNING',
}

export const LIST_NOTIFICATION_LEVEL: any = {
  INFO: new NotificationLevel({ code: NotificationLevelEnum.INFO, icon: 'fas fa-bell', color: 'text-info' }),
  SUCCESS: new NotificationLevel({ code: NotificationLevelEnum.SUCCESS, icon: 'fas fa-circle-check', color: 'text-success' }),
  ERROR: new NotificationLevel({ code: NotificationLevelEnum.ERROR, icon: 'fas fa-circle-xmark', color: 'text-danger' }),
  WARNING: new NotificationLevel({ code: NotificationLevelEnum.WARNING, icon: 'fas fa-triangle-exclamation', color: 'text-warning' }),
};

export enum NotificationStatusEnum {
  PUSHED = 'PUSHED',
  DELAYED = 'DELAYED',
  CLOSED = 'CLOSED',
}

export enum NotificationKeyEnum {
  NEW_BILL_GENERATE = 'NEW_BILL_GENERATE',
  BILL_STATUS_CHANGE_PAYED = 'BILL_STATUS_CHANGE_PAYED',
  BILL_STATUS_CHANGE_ISSUED = 'BILL_STATUS_CHANGE_ISSUED',
  TRANSPORT_ORDER_DELIVERY_STATUS_CHANGE = 'TRANSPORT_ORDER_DELIVERY_STATUS_CHANGE',
  TRANSPORT_ORDER_DELIVERY_STATUS_CHANGE_DELIVERED = 'TRANSPORT_ORDER_DELIVERY_STATUS_CHANGE_DELIVERED',
  TRANSPORT_ORDER_DELIVERY_STATUS_CHANGE_ISSUED = 'TRANSPORT_ORDER_DELIVERY_STATUS_CHANGE_ISSUED',

  // QUOTATION
  QUOTATION_NEW = 'QUOTATION_NEW',
  QUOTATION_TRANSPORTER_ACCEPTED = 'QUOTATION_TRANSPORTER_ACCEPTED',
  QUOTATION_TRANSPORTER_REJECTED = 'QUOTATION_TRANSPORTER_REJECTED',
  QUOTATION_TRANSPORTER_EXPIRED_PICKUP_DATE = 'QUOTATION_TRANSPORTER_EXPIRED_PICKUP_DATE',
  QUOTATION_CUSTOMER_ACCEPTED = 'QUOTATION_CUSTOMER_ACCEPTED',
  QUOTATION_CUSTOMER_REJECTED = 'QUOTATION_CUSTOMER_REJECTED',
  QUOTATION_CUSTOMER_EXPIRED_VALIDITY_DATE = 'QUOTATION_CUSTOMER_EXPIRED_VALIDITY_DATE',
  QUOTATION_CUSTOMER_EXPIRED_PICKUP_DATE = 'QUOTATION_CUSTOMER_EXPIRED_PICKUP_DATE',
  QUOTATION_CUSTOMER_ACCEPTED_BUT_EXPIRED_VALIDITY_DATE = 'QUOTATION_CUSTOMER_ACCEPTED_BUT_EXPIRED_VALIDITY_DATE',
  QUOTATION_CUSTOMER_ACCEPTED_BUT_EXPIRED_PICKUP_DATE = 'QUOTATION_CUSTOMER_ACCEPTED_BUT_EXPIRED_PICKUP_DATE',

  // Initiation de virement
  BILL_PAYMENT_LATE = 'BILL_PAYMENT_LATE',
  BILL_PAYMENT_LATE_RELAUNCH_1 = 'BILL_PAYMENT_LATE_RELAUNCH_1',
  BILL_PAYMENT_LATE_RELAUNCH_2 = 'BILL_PAYMENT_LATE_RELAUNCH_2',
  BILL_PAYMENT_LATE_RELAUNCH_3 = 'BILL_PAYMENT_LATE_RELAUNCH_3',

  // Basket pas payé
  BASKET_NOT_PAID = 'BASKET_NOT_PAID',

  // IMPORTS
  PRICING_NOT_IMPORTED_FOR_CUSTOMER = 'PRICING_NOT_IMPORTED_FOR_CUSTOMER',
  PRICING_IMPORTED_FOR_CUSTOMER = 'PRICING_IMPORTED_FOR_CUSTOMER',
}
